import Machines_D_0 from './Machines_D/Machines_D_0'
import Machines_D_1 from './Machines_D/Machines_D_1'
import Machines_D_2 from './Machines_D/Machines_D_2'
import Machines_D_3 from './Machines_D/Machines_D_3'
import Machines_D_4 from './Machines_D/Machines_D_4'
import Machines_D_5 from './Machines_D/Machines_D_5'
import Machines_D_6 from './Machines_D/Machines_D_6'
import Machines_D_7 from './Machines_D/Machines_D_7'
import Machines_D_8 from './Machines_D/Machines_D_8'

const Machines_D = [
  Machines_D_0,
  Machines_D_1,
  Machines_D_2,
  Machines_D_3,
  Machines_D_4,
  Machines_D_5,
  Machines_D_6,
  Machines_D_7,
  Machines_D_8,
  null,
  null,
  null
]

export default Machines_D



// WEBPACK FOOTER //
// ./src/components/Machines_D.js